import { motion } from "motion/react";
import type { ReactElement } from "react";

export const defaultIconPath="/icons/";
export const oldIconPath="/icons_old/";
export const CreateIconOld=(standardName:string):string=>{
  return`${oldIconPath}${standardName}.ico`;};
export const CreateIcon=(standardName:string,size:string="256",fileExtension:string="png"):string=>{
  return`${defaultIconPath}${size==="scalable"?size:`${size}x${size}`}/${standardName}.${fileExtension}`;};
export interface IWindowSymbols{
  close:string;
  min:string;
  max:string;
  unmax:string;
  search:string;
};
export const WindowSymbols:IWindowSymbols={
  //🗙︎🗕🗖︎🗗︎
  close:"🗙︎",
  min:"🗕",
  max:"🗖︎",
  unmax:"🗗︎",
  search:"⌕",
};
export interface IIcons{[key:string]:string;}
export const Icons:IIcons={
  beanpowered:"/apps/beanpowered/bp.png",
  beanforgedDark:"/apps/beanforged/beanforge.png",
  beancord:"/apps/beancord/beancord.png",
  beancordDark:"/apps/beancord/beancord-black.png",
  beanforged:"/apps/beanforged/bfl.png",
  beanshell:"/apps/beanshell/beanshell.png",
  firebean:"/apps/firebean/firebean.png",
  notepad:CreateIcon("apps/text-editor"),
  file:CreateIcon("mimetypes/empty"),
  application:CreateIcon("mimetypes/exec"),
  installer:CreateIcon("apps/system-software-install"),
  systemInstaller:CreateIcon("apps/system-installer"),
  text:CreateIcon("mimetypes/txt"),
  image:CreateIcon("mimetypes/image"),
  music:CreateIcon("mimetypes/sound"),
  video:CreateIcon("mimetypes/video"),
  camcorder:CreateIcon("devices/camera-video"),
  internet:CreateIcon("categories/stock_internet"),
  internetAlt:CreateIcon("places/network_local"),
  printer:CreateIcon("devices/printer"),
  printerSuccess:CreateIcon("actions/filequickprint"),
  photos:CreateIcon("apps/eog"),
  printerNetwork:CreateIcon("devices/printer-network"),
  controlPanel:CreateIcon("categories/preferences-system"),
  floppyDiskDrive:CreateIcon("devices/system-floppy"),
  cdDrive:CreateIcon("devices/drive-cdrom"),
  drive:CreateIcon("devices/drive-harddisk"),
  windowsDrive:CreateIcon("devices/drive-harddisk-system"),
  dvdDrive:CreateIcon("devices/media-optical-dvd"),
  unknownDrive:CreateIconOld("75"),
  dvd:CreateIconOld("56"),
  dvdr:CreateIconOld("38"),
  dvdram:CreateIconOld("39"),
  dvdrom:CreateIconOld("40"),
  dvdrw:CreateIconOld("41"),
  cd:CreateIcon("devices/cdrom_unmount"),
  cdr:CreateIconOld("62"),
  cdrom:CreateIconOld("63"),
  cdrw:CreateIconOld("64"),
  music2:CreateIconOld("85"),
  recyclingBinFull:CreateIcon("places/user-trash"),
  recyclingBinEmpty:CreateIcon("status/user-trash-full"),
  ipod:CreateIcon("devices/multimedia-player"),
  search:CreateIcon("actions/system-search"),
  configFile:CreateIconOld("67"),
  configApplication:CreateIconOld("68"),
  configTextFile:CreateIconOld("69"),
  drawing:CreateIconOld("70"),
  painting:CreateIconOld("71"),
  transparentImage:CreateIconOld("82"),
  fax:CreateIconOld("76"),
  directory:CreateIcon("places/folder"),
  directoryFont:CreateIconOld("77"),
  directoryMusic:CreateIcon("places/folder-music"),
  directoryDocuents:CreateIcon("places/folder-documents"),
  directoryImages:CreateIcon("places/folder-pictures"),
  directoryVideos:CreateIcon("places/folder-videos"),
  directoryStarred:CreateIcon("places/user-bookmarks"),
  directorySavedSearch:CreateIcon("places/user-saved-search"),
  directoryUser:CreateIcon("places/user-home"),
  directoryDesktop:CreateIcon("places/user-desktop"),
  directoryDownloads:CreateIcon("places/folder-download"),
  directoryUsers:CreateIcon("places/folder-publicshare"),
  directoryFonts:CreateIcon("apps/fonts"),
  directoryGames:CreateIconOld("186"),
  debian:CreateIcon("places/debian-swirl"),
  administrator:CreateIcon("status/dialog-password"),
  users:CreateIcon("apps/system-users"),
  info:CreateIcon("status/dialog-information"),
  warning:CreateIcon("status/dialog-warning"),
  error:CreateIcon("status/dialog-error"),
  help:CreateIcon("status/dialog-question"),
  delete:CreateIcon("actions/edit-delete"),
  new:CreateIcon("actions/window-new","48"),
  copy:CreateIcon("actions/edit-copy","48"),
  paste:CreateIcon("actions/edit-paste","48"),
  undo:CreateIcon("actions/document-revert"),
  redo:CreateIcon("actions/document-revert-rtl"),
  back:CreateIcon("actions/back"),
  forward:CreateIcon("actions/forward"),
  save:CreateIcon("actions/filesave"),
  exit:CreateIcon("actions/exit"),
  restart:CreateIcon("apps/access"),
  run:CreateIcon("actions/system-run"),
  find:CreateIcon("actions/edit-find"),
  rename:CreateIconOld("94"),
  mobileDevice:CreateIcon("devices/phone-apple-iphone"),
  mobileDeviceApple:CreateIcon("devices/phone-apple-iphone"),
  mobileDeviceSamsung:CreateIcon("devices/phone-samsung-galaxy-s"),
  screensaver:CreateIcon("apps/screensaver"),
  sdCard:CreateIconOld("96"),
  presentation:CreateIcon("mimetypes/x-office-presentation"),
  spreadsheet:CreateIcon("mimetypes/x-office-spreadsheet"),
  document:CreateIcon("mimetypes/x-office-document"),
  presentationTemplate:CreateIcon("mimetypes/x-office-presentation-template"),
  spreadsheetTemplate:CreateIcon("mimetypes/x-office-spreadsheet-template"),
  documentTemplate:CreateIcon("mimetypes/x-office-document-template"),
  shellscript:CreateIcon("mimetypes/shellscript"),
  iso:CreateIcon("mimetypes/application-x-cd-image"),
  html:CreateIcon("mimetypes/text-html"),
  registry:CreateIconOld("111"),
  computer:CreateIcon("devices/system"),
  font:CreateIcon("mimetypes/font"),
  trueTypeFontFile:CreateIconOld("125"),
  openTypeFontFile:CreateIconOld("127"),
  multimediaFile:CreateIconOld("134"),
  musicDvd:CreateIconOld("135"),
  videoDvd:CreateIconOld("136"),
  bluerayDrive:CreateIconOld("140"),
  videoCdDrive:CreateIconOld("141"),
  superVideoCdDrive:CreateIconOld("142"),
  missingDiscDrive:CreateIconOld("146"),
  burningDisc:CreateIconOld("155"),
  taskManagerOld:CreateIconOld("150"),
  taskManager:CreateIcon("apps/gnome-monitor"),
  bluetooth:CreateIcon("apps/bluetooth"),
  verified:CreateIconOld("157"),
  shortcut:CreateIconOld("163"),
  zip:CreateIcon("mimetypes/zip"),
  peripheral:CreateIcon("devices/input-keyboard"),
  peripheralKeyboard:CreateIcon("devices/input-keyboard"),
  peripheralMouse:CreateIcon("devices/input-mouse"),
  videoFrame169:CreateIconOld("194"),
  videoFrame43:CreateIconOld("193"),
  user:CreateIconOld("1029"),
  bitlockerDisabled:CreateIconOld("1035"),
  bitlocker:CreateIconOld("1036"),
  bitlockerError:CreateIconOld("1037"),
  bitlockerCDrive:CreateIconOld("1033"),
  bitlockerErrorCDrive:CreateIconOld("1034"),
  pin:CreateIconOld("5100"),
  sheild:CreateIconOld("SHIDI_SHIELD_INTERNAL"),
  fileManager:CreateIcon("apps/file-manager"),
  properties:CreateIcon("actions/document-properties"),
  open:CreateIcon("actions/document-open"),
  findReplace:CreateIcon("actions/edit-find-replace"),
  selectAll:CreateIcon("actions/edit-select-all"),
  goUp:CreateIcon("actions/go-up"),
  goDown:CreateIcon("actions/go-down"),
  goFirst:CreateIcon("actions/go-first"),
  goLast:CreateIcon("actions/go-last"),
  close:CreateIcon("actions/edit-clear-symbolic","scalable","svg"),
  plus:CreateIcon("actions/add","48"),
};
export const Icon=(props:{icon:keyof IIcons;elmtype?:keyof typeof motion;[key:string]:any}):ReactElement=>{
  const{icon,elmtype="div",...rest}=props;
  const Comp=motion[elmtype] as any;
  return(<Comp {...rest} style={{
    backgroundImage:`url(${Icons[icon]||icon})`,
    backgroundPosition:"center",
    backgroundSize:"contain",
    backgroundRepeat:"no-repeat"
  }}/>);
};
export const iconPathToIcon=(x:string):string=>Object.keys(Icons).find(i=>Icons[i]===x)as string;
export const DesktopIcons:{
  id:string,
  target:string,
  icon:string,
  title:string
}[]=[
  {
    id:"i1",
    title:"Welcome",
    target:"win1",
    icon:Icons.application
  },{
    id:"i2",
    title:"Settings",
    target:"settings",
    icon:Icons.configApplication
  },{
    id:"i3",
    title:"Beanpowered",
    target:"beanpowered",
    icon:Icons.beanpowered
  },{
    id:"i4",
    title:"Beanforged",
    target:"beanforged",
    icon:Icons.beanforged
  },{
    id:"i5",
    title:"Blog",
    target:"blog",
    icon:Icons.text
  },{
    id:"i6",
    title:"Beanshell",
    target:"beanshell",
    icon:Icons.beanshell
  },{
    id:"i7",
    title:"Explorer",
    target:"explorer",
    icon:Icons.fileManager
  },{
    id:"i8",
    title:"Notepad",
    target:"notepad",
    icon:Icons.notepad
  },{
    id:"i9",
    title:"Task Manager",
    target:"taskmgr",
    icon:Icons.taskManager
  },{
    id:"i10",
    title:"Beancord",
    target:"beancord",
    icon:Icons.beancord
  },{
    id:"i11",
    title:"Firebean",
    target:"firebean",
    icon:Icons.firebean
  },{
    id:"i12",
    title:"Mod Store",
    target:"modstore",
    icon:Icons.controlPanel
  },
];
export const StartMenuIcon:{
  name:string;
  background:string;
  icon:string;
  target:string;
}[]=[
  {
    name:"Welcome",
    background:"#0CA2FF",
    icon:Icons.application,
    target:"win1",
  },{
    name:"Changelog",
    background:"#27D260",
    icon:Icons.text,
    target:"changelog",
  },{
    name:"Settings",
    background:"#D653E7",
    icon:Icons.configApplication,
    target:"settings",
  },{
    name:"Beanpowered",
    background:"#3b5998",
    icon:Icons.beanpowered,
    target:"beanpowered",
  },{
    name:"Beanforged",
    background:"#1DA1f2",
    icon:Icons.beanforged,
    target:"beanforged",
  },{
    name:"Blog",
    background:"#95FF00",
    icon:Icons.text,
    target:"blog",
  },{
    name:"Beanshell",
    background:"#FF5722",
    icon:Icons.beanshell,
    target:"beanshell",
  },{
    name:"Explorer",
    background:"#F20D5E",
    icon:Icons.fileManager,
    target:"explorer",
  },{
    name:"Notepad",
    background:"#00d4ff",
    icon:Icons.notepad,
    target:"notepad",
  },{
    name:"Task Manager",
    background:"#00BFA5",
    icon:Icons.taskManager,
    target:"taskmgr",
  },{
    name:"Beancord",
    background:"#FDD835",
    icon:Icons.beancord,
    target:"beancord",
  },{
    name:"Firebean",
    background:"#C62828",
    icon:Icons.firebean,
    target:"firebean",
  },{
    name:"Mod Store",
    background:"#D653E7",
    icon:Icons.controlPanel,
    target:"modstore",
  },
];
export const IconsOld:IIcons={
  file:CreateIconOld("2"),
  application:CreateIconOld("15"),
  installer:CreateIconOld("87"),
  text:CreateIconOld("19"),
  mail:CreateIconOld("20"),
  imageAlt:CreateIconOld("21"),
  music:CreateIconOld("22"),
  camcorder:CreateIconOld("46"),
  phoneDeviceOld:CreateIconOld("48"),
  // commandPrompt:CreateIcon("d1f5fcw-533b556a-a161-4cc6-b9d7-67037b797373"),
  beanpowered:"/apps/beanpowered/bp.png",
  beanforgedDark:"/apps/beanforged/beanforge.png",
  beanforged:"/apps/beanforged/bfl.png",
  beanshell:"/apps/beanshell/beanshell.png",
  // multibeanmc:"/apps/mbmc/logo.png",
  // firebean:"/apps/firebean/favicon.png",
  video:CreateIconOld("23"),
  internet:CreateIconOld("25"),
  printer:CreateIconOld("51"),
  printSuccess:CreateIconOld("49"),
  networkPrinter:CreateIconOld("53"),
  networkPrinterSuccess:CreateIconOld("50"),
  internetPrinter:CreateIconOld("45"),
  controlPanel:CreateIconOld("27"),
  floppyDiskDrive:CreateIconOld("28"),
  disketteDrive:CreateIconOld("29"),
  cdDrive:CreateIconOld("30"),
  drive:CreateIconOld("35"),
  windowsDrive:CreateIconOld("36"),
  dvdDrive:CreateIconOld("37"),
  unknownDrive:CreateIconOld("75"),
  dvd:CreateIconOld("56"),
  dvdr:CreateIconOld("38"),
  dvdram:CreateIconOld("39"),
  dvdrom:CreateIconOld("40"),
  dvdrw:CreateIconOld("41"),
  cd:CreateIconOld("61"),
  cdr:CreateIconOld("62"),
  cdrom:CreateIconOld("63"),
  cdrw:CreateIconOld("64"),
  music2:CreateIconOld("85"),
  recyclingBinFull:CreateIconOld("54"),
  recyclingBinEmpty:CreateIconOld("55"),
  ipod:CreateIconOld("66"),
  search:CreateIconOld("177"),
  configFile:CreateIconOld("67"),
  configApplication:CreateIconOld("68"),
  configTextFile:CreateIconOld("69"),
  drawing:CreateIconOld("70"),
  image:CreateIconOld("72"),
  painting:CreateIconOld("71"),
  transparentImage:CreateIconOld("82"),
  fax:CreateIconOld("76"),
  directory:CreateIconOld("3"),
  fontDirectory:CreateIconOld("77"),
  musicDirectory:CreateIconOld("108"),
  documentDirectory:CreateIconOld("112"),
  imageDirectory:CreateIconOld("113"),
  starredDirectory:CreateIconOld("115"),
  userDirectory:CreateIconOld("123"),
  desktopDirectory:CreateIconOld("183"),
  downloadsDirectory:CreateIconOld("184"),
  shortcutsDirectory:CreateIconOld("185"),
  administrator:CreateIconOld("78"),
  users:CreateIconOld("88"),
  info:CreateIconOld("81"),
  warning:CreateIconOld("84"),
  error:CreateIconOld("98"),
  help:CreateIconOld("99"),
  xmark:CreateIconOld("89"),
  restart:CreateIconOld("86"),
  run:CreateIconOld("100"),
  rename:CreateIconOld("94"),
  mobileDevice:CreateIconOld("93"),
  screensaver:CreateIconOld("101"),
  sdCard:CreateIconOld("96"),
  presentation:CreateIconOld("103"),
  registry:CreateIconOld("111"),
  computer:CreateIconOld("109"),
  fontFile:CreateIconOld("124"),
  trueTypeFontFile:CreateIconOld("125"),
  openTypeFontFile:CreateIconOld("127"),
  musicFile:CreateIconOld("131"),
  imageFile:CreateIconOld("132"),
  videoFile:CreateIconOld("133"),
  multimediaFile:CreateIconOld("134"),
  musicDvd:CreateIconOld("135"),
  videoDvd:CreateIconOld("136"),
  bluerayDrive:CreateIconOld("140"),
  videoCdDrive:CreateIconOld("141"),
  burningDisc:CreateIconOld("155"),
  superVideoCdDrive:CreateIconOld("142"),
  properties:CreateIconOld("145"),
  missingDiscDrive:CreateIconOld("146"),
  taskManager:CreateIconOld("150"),
  verified:CreateIconOld("157"),
  shortcut:CreateIconOld("163"),
  zipFile:CreateIconOld("174"),
  internet2:CreateIconOld("179"),
  peripheral:CreateIconOld("182"),
  gamesDirectory:CreateIconOld("186"),
  videoDirectory:CreateIconOld("189"),
  videoFrame169:CreateIconOld("194"),
  videoFrame43:CreateIconOld("193"),
  blocked:CreateIconOld("1027"),
  user:CreateIconOld("1029"),
  bitlockerDisabled:CreateIconOld("1035"),
  bitlocker:CreateIconOld("1036"),
  bitlockerError:CreateIconOld("1037"),
  bitlockerCDrive:CreateIconOld("1033"),
  bitlockerErrorCDrive:CreateIconOld("1034"),
  pin:CreateIconOld("5100"),
  sheild:CreateIconOld("SHIDI_SHIELD_INTERNAL"),
};